<div *ngIf="isLoading | async" class="overlay">
  <img class="centered" src="/assets/img/loading.gif" width="150px">
</div>
